import storage from '@/Common/libs/storage.js';
import cookie from 'js-cookie';

// import md5 from 'md5';
class BuryPoint {
  constructor() {
    this.timestampPool = {};
    this.trackTimerId = {};
  }
  preCheck() {
    this.userId = storage.get(storage.NAME.USER).installerId;
    if (this.userId) {
      // window.gtag('set', {'user_id': md5(this.userId)});
      // console.log('------------ google analytics user id 设置成功 （from buried point）-----------');
    }
    if (!cookie.get('_gid')) {
      // eslint-disable-next-line no-console
      console.error('gid disappear');
    }
  }
  getPreDemoStr() {
    const isTourist = JSON.parse(storage.realGet(storage.NAME.TOURIST_MODE));
    const preStr = isTourist ? 'demo' : '';
    return preStr;
  }

  pageView({ pageTitle, pagePath, pageLocation, custom = {} }) {
    const preStr = this.getPreDemoStr();
    window.gdp && window.gdp('track', 'page_event', {
      page_title: preStr + pageTitle,
      page_path: preStr + pagePath,
      page_location: preStr + pageLocation,
      custom
    });
  }

  event({ action, eventCategory, eventLabel, value }) {
    this.preCheck();
    const preStr = this.getPreDemoStr();
    window.gdp && window.gdp('track', 'custom_event', {
      event_category: preStr + eventCategory,
      event_action: preStr + action,
      event_label: preStr + eventLabel,
      value: value
    });
  }

  timing({ name, value, eventCategory, eventLabel }) {
    const preStr = this.getPreDemoStr();
    let _that = this;
    if (value) {
      if (!name) {
        // eslint-disable-next-line no-console
        console.error('please pass timestamp name');
        return;
      }
      if (name in this.trackTimerId) {
        delete this.trackTimerId[name];
      }
      this.trackTimerId[name] = {};

      this.trackTimerId[name].start = new Date().getTime();
      this.trackTimerId[name].end = new Date().getTime();

      window.gdp && window.gdp('trackTimerStart', 'timing_complete', (timerId) => {
        _that.trackTimerId[name].timerId = timerId;
      });

      this.trackTimerId[name].setTimeout = setTimeout(() => {
        if (name in _that.trackTimerId) {
          _that.trackTimerId[name].end = new Date().getTime();
          _that.trackTimerId[name].timeDiffer = _that.trackTimerId[name].end - _that.trackTimerId[name].start;
          if (_that.trackTimerId[name].timeDiffer - value < 2000) {
            window.gdp && window.gdp('trackTimerEnd', _that.trackTimerId[name].timerId, {
              name: preStr + name,
              value: value,
              event_category: preStr + eventCategory,
              event_label: preStr + eventLabel
            });
          } else {
            window.gdp && window.gdp('removeTimer', _that.trackTimerId[name].timerId);
          }
          clearTimeout(_that.trackTimerId[name].setTimeout);
          delete _that.trackTimerId[name];
        }
      }, value);
    }
  }

  timestamp(name, flag) {
    if (!name) {
      // eslint-disable-next-line no-console
      console.error('please pass timestamp name');
      return;
    }
    if (name in this.timestampPool) {
      if (flag === 'start') {
        this.timestampPool[name].start = new Date().getTime();
        return this.timestampPool[name].start;
      } else if (flag === 'end') {
        this.timestampPool[name].end = new Date().getTime();
        const time = this.timestampPool[name].end - this.timestampPool[name].start;
        delete this.timestampPool[name];
        return time;
      }
      // eslint-disable-next-line no-console
      console.error('timestamp function error.');
    } else {
      const startTime = new Date().getTime();
      this.timestampPool[name] = {};
      if (flag === 'start') {
        this.timestampPool[name].start = startTime;
        return this.timestampPool[name].start;
      }
      // eslint-disable-next-line no-console
      console.error('you must pass start parameter first.');
    }
  }
}
const instance = new BuryPoint();

export const buryPoint = instance;
